// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealsItem_meal__16RyD","description":"MealsItem_description__1ZU8J","price":"MealsItem_price__21W0I"};